import React from "react";
import ChatBotWidget from "../../demo/chatBotWidget";
import "../../App.css";

function App() {
  return (
    <div className="App">
      {/* Your main application content goes here */}
      <div className="main-content">
        <h1>Your Application</h1>
        <p>
          This is your main application page with a floating chatbot widget.
        </p>

        {/* Example content */}
        <section className="content-section">
          <h2>Welcome to Our Platform</h2>
          <p>
            This is a demo of a FAQ chatbot widget. The chatbot floats in the
            bottom-right corner and can answer questions about your application.
          </p>
        </section>
      </div>

      {/* Floating Chatbot Widget */}
      <ChatBotWidget />
    </div>
  );
}

export default App;
